import { UpdateUserDetailParams } from "./UserNotificationInfoUpdate"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CreateUser(params: UpdateUserDetailParams) {
  const requestBody = JSON.stringify({
    // ApplicationUserID: params.ApplicationUserID,
    EmailAddressList: params.EmailAddressList.map((item) => ({
      EmailAddress: item.ContactDetail,
      isActive: item.Active,
      DeliveryType: "EMAIL",
    })),
    FirstName: params.FirstName,
    IsNotificationEnabled: params.IsNotificationEnabled,
    // IsUser: params.IsUser,
    LastName: params.LastName,
    Link: window.location.hostname,
    // ModifiedBy: params.ModifiedBy,
    NotificationEventIDs: params.NotificationEventIDs,
    NotificationServiceIDs: params.NotificationServiceIDs,
    NotificationMethodIDs: params.NotificationMethodIDs,
    ParticipationID: params.ParticipationID,
    PhoneNumberList: params.PhoneNumberList.map((item) => ({
      PhoneNumber: item.ContactDetail,
      isActive: item.Active,
      DeliveryType: item.DeliveryType,
    })),
    RoleList: params.RoleList.map((item) => ({ RoleID: item.RoleID, RoleTitle: item.Title, IsActive: item.Active, Level: item.Level })),
    UserName: params.UserName,
    timeZoneID: params.timeZoneID,
    isCollectorActive: params.isCollectorActive,
    AccountID: params.AccountID,
    LocationID: params.LocationID,
    Inactive: params.Inactive,
  })

  return ObservableFromFetch<string>("FFOrderUserFileMaintenance/CreateUser", requestBody)
}
